import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';

@Component({
  selector: 'app-invitestudent',
  templateUrl: './invitestudent.component.html',
  styleUrls: ['./invitestudent.component.css']
})
export class InvitestudentComponent {
  @ViewChild('email') email: ElementRef;
  moduleid: number;
  schoolid: number;
  moduleinfo: any;

  constructor(private toastr: ToastrService, private headerinfo: ComponentheaderService,
    private schoolmanager: SchoolmanagementService, private route: ActivatedRoute,
    public modulemanager: ModulemanagementService) { }

  async ngOnInit() {
    try {
      this.moduleid = this.route.snapshot.queryParams.moduleid;
      this.headerinfo.setHeaderDisplay(
        `Invite Student`,
        [
          {
            displaytext: 'School',
            route: `/user/schoolhome`,
          },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.moduleid },
          },
          {
            displaytext: `Invite Student`,
            route: `/user/invitestudent`,
            params: this.route.snapshot.queryParams,
          },
        ],
        []
      );
      this.schoolid = await this.schoolmanager.getSchoolIdFromSubdomain().toPromise();
    }
    catch (e) {
      console.log('error:', e);
    }
  }

  async inviteStudent() {
    try {
      if (!this.email.nativeElement.value) {
        this.toastr.error("Enter User Email");
        throw new Error("Enter User Email");
      }
      if (this.moduleid > 0) {
        let data = {
          moduleId: this.moduleid,
          email: this.email.nativeElement.value,
        };
        await this.modulemanager.sendStudentInvite(data).toPromise();
        this.toastr.success('Sucessful');
        this.email.nativeElement.value = '';
      }
    }
    catch (e) {
      this.toastr.error(e.message);
      console.log('error:', e);
    }    
  }
}
